<div class="modal-header">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">

      <div *ngIf="isLoading" style="display: flex; align-items: center;">
         <span class="loading-icon-small"></span> Loading, Please wait.
      </div>

      <span *ngIf="!isLoading" [innerHTML]="text"></span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()">Confirm</button>
</div>
